import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2d316234"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d316234')) {
      api.createRecord('2d316234', component.options)
    } else {
      api.reload('2d316234', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2d316234", function () {
      api.rerender('2d316234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/layout/Index.vue"
export default component.exports